import styled from "@emotion/styled";

export const StyledAvatarContainer = styled.div<{
  $size: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  flex-shrink: 0;
  overflow: hidden;
  height: ${({ $size }) => `${$size}px`};
  width: ${({ $size }) => `${$size}px`};
  border-radius: 50%;
  font-size: ${({ $size }) => `${Math.max(10, Math.floor($size * 0.6))}px`};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const StyledAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledAnonIcon = styled.svg`
  width: 100%;
  height: 100%;
`;
